import { render, staticRenderFns } from "./HowItWorksItemLeft.vue?vue&type=template&id=86a7cc54&"
import script from "./HowItWorksItemLeft.vue?vue&type=script&lang=js&"
export * from "./HowItWorksItemLeft.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports